import { useToastDispatch } from 'contexts/toasts/toast-context'

export default function useShowSuccess() {
	const dispatch = useToastDispatch()

	return ( id: string, message: string ) => {
		dispatch( {
			type: 'addToast',
			payload: {
				id: `${id}-success`,
				title: message,
				color: 'success',
			}
		} )
	}
}
